import { notNullLike } from "./notNullLike";

export function ensureArray<T>(it: T[] | null | undefined): T[] {
	return notNullLike(it) ? it : [];
}
